
































import {Component, Prop, Vue} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import TrackingOrderStatusLabel from '@/components/TrackingOrderStatusLabel.vue';
import {ITrackingOrder} from '@/models/ITrackingOrder';
import TrackingOrderNonUpdatedCountLabel from '@/components/TrackingOrderNonUpdatedCountLabel.vue';
import TrackingEditScreen from '@/screens/dashboard/tracking/TrackingEditScreen.vue';
import Tracking from '@/screens/dashboard/tracking/Tracking.vue';


@Component({
  components: {
    Tracking,
    TrackingOrderStatusLabel,
    TrackingOrderNonUpdatedCountLabel,
    TrackingEditScreen
  }
})
export default class TrackingTable extends Vue {
  @Prop() loading: boolean;
  @Prop({required: true}) trackings: ITrackingOrder[];

  updateTrackingNumber(trackingNumber: string, trackingId: number) {
    this.$emit('trackingNumberChanged', trackingNumber, trackingId);
  }

  headers: DataTableHeader[] = [
    {text: 'Order Name', sortable: true, value: 'order_name'},
    {text: 'Tracking Number', sortable: true, value: 'tracking_number'},
    {text: 'Start Date', sortable: true, value: 'started_at'},
    {text: 'Status', align: 'center', sortable: true, value: 'status'},
    {text: 'Information', sortable: false, value: 'tracking_info'},
    {text: 'Updated Date', sortable: true, value: 'latest_updated_at'},
    {text: 'NoUpdated Days', align: 'center', sortable: true, value: 'non_updated_count'},
    {text: 'Supplier', sortable: true, value: 'supplier_name'},
    {text: 'Action', sortable: false, value: ''},
  ];
}
